<template>
  <div>
    <router-view/>
    <modal-container ref="modal-container"/>
  </div>
</template>

<script>
import ModalContainer from '@/components/core/modal/ModalContainer.vue';

export default {
  name: 'App',
  components: {
    ModalContainer,
  },
};
</script>

<style lang="scss">
@import 'styles/main.scss';
</style>
